import { Component, enableProdMode } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Fantasy League Punisher';
}

enableProdMode()




// WEBPACK FOOTER //
// /Users/zachbrugman/Development/my-app/src/app/app.component.ts